module.exports = __webpack_public_path__ + "static/03-8c9a498ad19ffb5267112f21a510338e.jpg";